<script>import { twMerge } from 'tailwind-merge';
import { get_current_component } from 'svelte/internal';
import { forwardEventsBuilder, useActions } from '../../actions';
export let use = [];
import { exclude } from '../../utils/exclude';
const forwardEvents = forwardEventsBuilder(get_current_component());
const defaultClass = 'feed -mb-8 stwui-feed';
$: finalClass = twMerge(defaultClass, $$props.class);
</script>

<div class="flow-root">
	<ul
		class={finalClass}
		use:useActions={use}
		use:forwardEvents
		{...exclude($$props, ['use', 'class'])}
	>
		<slot />
	</ul>
</div>

<style global>
	:global(.feed :global(.item:last-child) :global(.connector)) {
		display: none;
	}
</style>
